export default "__VITE_ASSET__BNY5ynOc__"